import { CustomLoginModeEnum } from '../../pages/custom-login/entities/CustomLogin'

export const CHANGE_CUSTOM_LOGIN_MODE = 'CHANGE_CUSTOM_LOGIN_MODE'

export type ChangeCustomLoginMode = {
  type: typeof CHANGE_CUSTOM_LOGIN_MODE
  payload: CustomLoginModeEnum
}
